import Notifications from '@/components/notifications/notifications';
import {
  ROUTE_ACTION_PLAN,
  ROUTE_DASHBOARD,
  ROUTE_RISK_ANALYSIS,
  ROUTE_RISK_TREND,
  ROUTE_TESTING_PLAN,
} from '@/constants/routes';
import useIsMobile from '@/hooks/use-is-mobile';
import { FeatureFlags, useFeatureFlags } from '@/services/feature-flag-provider';
import { getRoute } from '@/utils';
import { Box } from '@cmpsr/components';
import React from 'react';
import DashboardNavigationBarDesktop from './components/dashboard-navigation-bar-desktop';
import DashboardNavigationBarMobile from './components/dashboard-navigation-bar-mobile';
import useDashboardNavigationBarController from './dashboard-navigation-bar.controller';
import { NavigationBarProps, NavigationMenuItem } from './types';

const defaultMenuItems: Array<NavigationMenuItem> = [
  { label: 'Dashboard', href: ROUTE_DASHBOARD, item: 'home' },
  { label: 'Risk Analysis', href: ROUTE_RISK_ANALYSIS, item: 'risk-analysis' },
  { label: 'Action Plan', href: getRoute(ROUTE_ACTION_PLAN), item: 'action-plan' },
  { label: 'Testing Plan', href: ROUTE_TESTING_PLAN, item: 'testing-plan' },
] as const;

function NavigationBar(navBarProps: NavigationBarProps) {
  const { isEnabled } = useFeatureFlags();
  const isRiskTrendTabEnabled = isEnabled(FeatureFlags.IsRiskTrendTabEnabled);

  const additionalMenuItems: Array<NavigationMenuItem> = [
    ...(isRiskTrendTabEnabled ? [{ label: 'Risk Trend', href: ROUTE_RISK_TREND, item: 'risk-trend' } as const] : []),
  ];

  const menuItems = [...defaultMenuItems, ...additionalMenuItems];

  const { name, email, handleLogout, navBarRef, notificationRef } = useDashboardNavigationBarController();

  const isMobile = useIsMobile();

  const props = { name, email, handleLogout, menuItems, ...navBarProps };

  const dashboardNavBar = isMobile ? (
    <DashboardNavigationBarMobile {...props} navBarRef={navBarRef} />
  ) : (
    <DashboardNavigationBarDesktop {...props} navBarRef={navBarRef} />
  );

  return (
    <Box w="100%" position="sticky" top="0" zIndex="15">
      <Notifications notificationRef={notificationRef} />
      {dashboardNavBar}
    </Box>
  );
}

export default React.memo(NavigationBar);
